// Whether someone already opened a Boo's vault in this browser. The flag is
// per browser, not per person, and survives sign-out, so on a shared machine
// the next admin skips the warning. A storage that can't be read or written
// counts as "not opened", so the warning shows again.

type FlagStorage = Pick<Storage, "getItem" | "setItem">;

export const vaultOpenedKey = (containerId: string) => `boo.vaultOpened.${containerId}`;

function browserStorage(): FlagStorage | undefined {
  return typeof localStorage === "undefined" ? undefined : localStorage;
}

export function vaultOpened(containerId: string, storage: () => FlagStorage | undefined = browserStorage): boolean {
  try {
    return storage()?.getItem(vaultOpenedKey(containerId)) === "1";
  } catch {
    return false;
  }
}

export function rememberVaultOpened(containerId: string, storage: () => FlagStorage | undefined = browserStorage): void {
  try {
    storage()?.setItem(vaultOpenedKey(containerId), "1");
  } catch {
    return;
  }
}

// The warning shows for someone who can change this Boo's vault and hasn't
// opened it here yet; everyone else goes straight to the vault page. While it
// shows, nothing else renders, so no vault request goes out before
// "Open the vault".
export function showsVaultGate(p: { opened: boolean; isBrain: boolean; canManage: boolean }): boolean {
  return !p.opened && p.isBrain && p.canManage;
}
